"use client";

import { cn } from "@/lib/utils";
import type { CustomProduct } from "@apptus/esales-api";
import Stock from "../stock-status/Stock";

export default function ProductCardStockStatus({
  product,
  className,
}: {
  product: CustomProduct;
  className?: string;
}) {
  return (
    <Stock
      item={product}
      type="plp"
      className={cn("ml-auto text-sm", className)}
    />
  );
}

ProductCardStockStatus.displayName = "ProductCardStockStatus";
